// REACT
import React, { Component } from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// Custom Components
import { FluidSection } from 'components/FluidSection/index';
import Booking from './Booking';

// Vendor Components
import moment from 'moment-timezone';
import VisibilitySensor from 'react-visibility-sensor';

// Custom Utils
import {
    getTodaysDate,
    getUserTimezone,
    convertDateTimeToUserTimezone,
} from 'utils/timezoneUtils';
import { generateTokenFlag } from 'utils/database/database-utils';
import { constants } from '../../constants/index';
import { isStaging } from '../../firebase/firebase';

class ProUpcomingBookings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCompletedBookings: false,
            todayIsConsultDay: false,
        };
    }

    componentDidMount() {
        this.props.clearBookings();
        this.props.loadUpcomingDbBookings({
            clientUid:
                this.props.selectedClient && this.props.selectedClient.uid,
            serviceId: this.props.serviceId,
            userId: this.props.userData.uid,
            userType: 'provider',
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.serviceId !== this.props.serviceId) {
            this.props.loadUpcomingDbBookings({
                clientUid:
                    this.props.selectedClient && this.props.selectedClient.uid,
                serviceId: this.props.serviceId,
                userId: this.props.userData.uid,
                userType: 'provider',
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        // HIDE NEW NOTIFICATION BADGES WHILE THIS TAB IS MOUNTED AND VISIBLE
        if (this.props.newBookings !== nextProps.newBookings) {
            this.handleClearNotifications();
        }
    }

    handleGetFutureBookings = (userId, serviceSbmId, serviceId) => {
        return new Promise((resolve, reject) => {
            // console.log('SELECTED CLIENT @ FUTURE BOOKINGS', this.props.selectedClient);

            const bookingOptions = {
                bookings: this.props.userData && this.props.userData.bookings,
                clientUid:
                    this.props.selectedClient && this.props.selectedClient.uid,
                future: true,
                past: false,
                serviceId,
                serviceSbmId,
                userId,
            };
            // console.log('BOOKINGS BEING SENT TO GET BOOKINGS ARE', this.props.userData.bookings);

            this.props
                .getBookings(bookingOptions)
                .then(() => {
                    resolve();
                })
                .catch(e => reject(e));
        });
    };

    getSbmServiceId = () => {
        return new Promise((resolve, reject) => {
            if (this.props.serviceSbmId) {
                // console.log('WE HAVE SBM SERVICE!');
                resolve();
            }
        });
    };

    getUserData = () => {
        return new Promise((resolve, reject) => {
            if (this.props.userId && this.props.userData) {
                resolve(this.props.userId);
            }
        });
    };

    getConsultLink = booking => {
        const userTimezone = getUserTimezone();
        const {
            companyTimezone,
            startDate,
            startTime,
            companyStartDateTime,
        } = booking; // startDate is WRONG dont use
        // const { start_date_time } = booking.confirmationData;
        const startDateTime = convertDateTimeToUserTimezone(
            companyStartDateTime,
            userTimezone,
            companyTimezone,
        );
        // console.log(startDateTime.format('YYYY-MM-DD'), 'IS START DATE TIME$$%$%$%');
        const consultStartTimestamp = moment(
            `${companyStartDateTime}`,
            'YYYY-MM-DD HH:mm:ss',
        ).format('x');

        const todaysDate = getTodaysDate(
            companyTimezone,
            companyStartDateTime,
            userTimezone,
        );
        // console.log(`%cTODAY: ${JSON.stringify(todaysDate)} ${startDate} ${startTime}`,'color: greenyellow');

        // console.log('STARTDATE', todaysDate === startDate, this.state[booking.key] && this.state[booking.key].todayIsConsultDay);

        if (
            !this.state[booking.key] &&
            (todaysDate === startDateTime.format('YYYY-MM-DD') || isStaging) // if staging then let the user join the call even if the booking is in the future
        ) {
            this.setState(
                {
                    [booking.key]: {
                        todayIsConsultDay: true,
                    },
                },
                () => {
                    if (!booking.token || isStaging) {
                        // if staging then let the user generate a token even if the booking is in the future (it will just make a new token each time)
                        // console.log('There is no existing token in DB, adding one now...');
                        this.props.generateTokenFlag(
                            booking,
                            this.props.userId,
                        );
                    }
                },
            );
        }
        // console.log('PROPS TOKEN', this.props.token);

        // IF THE BOOKINGKEY STATE HAS BEEN CREATED THEN WE CAN ASUME THAT THE TOKEN HAS BEEN SET
        if (
            booking.confirmationData &&
            this.state[booking.key] &&
            this.state[booking.key].todayIsConsultDay
        ) {
            // console.log('REDUX TOKEN/BOOKING TOKEN', this.props.token, '/', booking.token);
            return `/consultations/${booking.confirmationData.hash}${
                booking.confirmationData.code
            }`;
        } else if (booking.confirmationData) {
            return `/check-back-soon/${consultStartTimestamp}`; // ADD TIMESTAMP AS QUERY PARAM TO SHOW A COUNT DOWN?
            // return `/consultations/${booking.confirmationData.hash}${booking.confirmationData.code}`; // TODO: get rid of this FOR TESTING ONLY
        }
    };

    handleClearNotifications = () => {
        const refreshProNotificationsUIElements = () => {
            // console.log('REFRESHING NOTIFICATIONS @ BookingsList');

            this.props.refreshNotifications();
            this.props.getNotificationCounts({
                senderId:
                    this.props.selectedClient && this.props.selectedClient.uid,
                serviceId: this.props.serviceId,
                userId: this.props.userData && this.props.userData.uid,
            });
        };

        if (this.props.userData && this.props.userData.provider) {
            this.props
                .clearNotifications({
                    clientId:
                        this.props.selectedClient &&
                        this.props.selectedClient.uid,
                    serviceId: this.props.serviceId,
                    type: 'newBooking',
                    userId: this.props.userData && this.props.userData.uid,
                })
                .then(() => {
                    refreshProNotificationsUIElements();
                })
                .catch(console.log);
        }
    };

    render() {
        const { futureBookings, providers } = this.props;

        return (
            <div
                className="bookings"
                style={{ display: 'flex', flex: 1, flexFlow: 'column nowrap' }}
            >
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                        flexFlow: 'column nowrap',
                    }}
                >
                    {futureBookings &&
                        providers &&
                        futureBookings.map((booking, i) => {
                            const {
                                startTime,
                                startDate,
                                providerId,
                                userDateTime,
                                key,
                                providerUid,
                                bookingStatus,
                            } = booking;

                            const filteredProviderArray = providers.filter(
                                provider => {
                                    if (provider.uid === providerUid) {
                                        return true;
                                    }
                                },
                            );
                            const bookingProviderData =
                                filteredProviderArray[0];

                            return (
                                <Booking
                                    booking={booking}
                                    isConfirmed={!!booking.confirmationData}
                                    isToday={
                                        this.state[booking.key] &&
                                        this.state[booking.key]
                                            .todayIsConsultDay
                                    }
                                    dateTime={userDateTime}
                                    bookingProviderData={bookingProviderData}
                                    getConsultLink={this.getConsultLink}
                                    key={i}
                                    userData={this.props.userData}
                                    providerUid={providerUid}
                                    providers={providers}
                                    status={bookingStatus}
                                />
                            );
                        })}
                    {this.props.futureBookings &&
                        this.props.futureBookings.length === 0 && (
                            <p style={styles.noBookingsNoticeStyles}>
                                There are no upcoming bookings for this{' '}
                                {this.props.userData.provider
                                    ? 'client'
                                    : 'service'}
                                .
                            </p>
                        )}
                    {
                        <VisibilitySensor
                            delay={0}
                            containment={document.querySelector('.bookings')}
                            delayedCall={true}
                            partialVisibility={true}
                            // active={!this.state.loadingPrevious}
                            onChange={this.handleClearNotifications}
                        />
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({
    auth,
    client,
    booking,
    router,
    video,
    provider,
    notification,
}) => {
    return {
        bookings: booking.data ? booking.data.bookings : null,
        futureBookings: booking.data ? booking.data.futureBookings : null,
        location: router.location,
        newBookings: notification.notifications.bookings,
        providers: booking.providers,
        selectedClient: provider.selectedClient,
        selectedProvider: booking.provider,
        token: video.token,
        userData: client.clientData,
        userId: auth.authData ? auth.authData.id : null,
    };
};

const styles = {
    date: {
        display: 'flex',
        flex: 2,
    },
    secondaryText: {
        display: 'flex',
        flex: 1,
        paddingLeft: 30,
        paddingRight: 10,
    },
    noBookingsNoticeStyles: {
        paddingTop: 60,
        fontSize: constants.text.baseFontStyles.fontSize,
        textAlign: 'center',
    },
};

export default connect(
    mapStateToProps,
    actions,
)(ProUpcomingBookings);



// WEBPACK FOOTER //
// ./src/js/components/Booking/ProUpcomingBookings.jsx